module.exports = __webpack_public_path__ + "img/qrcode.bb28a1e4.png";